import { IContentfulTag } from "../types/blog.types"

type TContentfulTagSlug = Omit<IContentfulTag, "name">

/** Normalizes route to add proceeding and trailing slashes */
export const normalizeForwardSlashes = (route: string): string => {
  if (!route) return "#"
  // we don't want to parse any of these options
  // we are only adjusting relative routes
  if (
    route.startsWith("#") ||
    route.startsWith("http://") ||
    route.startsWith("https://") ||
    route.startsWith("mailto:")
  ) {
    return route
  }
  let absoluteRoute = route
  if (!absoluteRoute.startsWith("/")) {
    absoluteRoute = `/${absoluteRoute}`
  }
  if (!absoluteRoute.endsWith("/")) {
    absoluteRoute = `${absoluteRoute}/`
  }
  return absoluteRoute
}

const Blog = (
  category?: TContentfulTagSlug,
  topic?: TContentfulTagSlug,
  slug?: string
) =>
  `/blog/${category?.slug ? `${category.slug}/` : ""}${
    topic?.slug ? `${topic.slug}/` : ""
  }${slug ? `${slug}/` : ""}`

const InternalRoutes = {
  Blog,
}

export default InternalRoutes
